import AppLoadPageMixin from "@/protected/mixins/AppLoadPageMixin";
import Editor from "./PersonEditor";
import service from "./PersonService";

export default {
  mixins: [AppLoadPageMixin],

  components: {
    Editor
  },

  methods: {
    getService() {
      return service;
    },

    getLabel(instance) {
      return instance.lastName + " " + instance.firstName;
    }
  }
};
